module.exports = __webpack_public_path__ + "src/assets/img/cmd-stop-engine-gray.3a5a7979.svg";